T.GallerySlider = Class(
	/**
	 * @lends {T.GallerySlider#}
	 */
	{
		__construct() {
			this.node = mkE({
				tag: 'div',
				className: 'glide gallery-slider',
				els: [
					{
						tag: 'div',
						className: 'glide__track',
						attr: {
							'data-glide-el': 'track'
						},
						els: [
							{
								tag: 'div',
								className: 'glide__slides gallery',
								els: this._galleryImages()
							}
						]
					}
				]
			});
		},

		_galleryImages() {
			const image = id => {
				return {
					tag: 'img',
					src: '/assets/images/home/gallery/' + id + '.jpg',
					srcset: '/assets/images/home/gallery/' + id + '@2x.jpg 2x,/assets/images/home/gallery/' + id + '@3x.jpg 3x',
					attr: {
						alt: ""
					}
				}
			}
			return [
				{
					tag: 'div',
					className: 'gallery-item',
					els: [
						image(122)
					]
				},
				{
					tag: 'div',
					className: 'gallery-item',
					els: [
						{
							tag: 'div',
							className: 'gallery-item-row',
							els: [
								image(679),
								image(213)
							]
						},
						{
							tag: 'div',
							className: 'gallery-item-row',
							els: [
								image(68),
								image(93)
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'gallery-item',
					els: [
						image(553)
					]
				},
				{
					tag: 'div',
					className: 'gallery-item',
					els: [
						{
							tag: 'div',
							className: 'gallery-item-row',
							els: [
								image(542),
								image(619)
							]
						},
						{
							tag: 'div',
							className: 'gallery-item-row',
							els: [
								image(170),
								image(628)
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'gallery-item',
					els: [
						image('122-copy')
					]
				},
				{
					tag: 'div',
					className: 'gallery-item',
					els: [
						{
							tag: 'div',
							className: 'gallery-item-row',
							els: [
								image('679-copy'),
								image('213-copy')
							]
						},
						{
							tag: 'div',
							className: 'gallery-item-row',
							els: [
								image('68-copy'),
								image('93-copy')
							]
						}
					]
				}
			];
		},

		_drawSlider: function(){
			let count = this._getGallerySliderCount();
			this._gallerySlider = new Glide('.gallery-slider', {
				type: 'carousel',
				startAt: 0,
				perView: count,
				focusAt: 'center',
				gap: 10,
				peek: this._getGallerySliderPeek(count),
				classes: {
					activeSlide: 'active'
				}
			});
			this._gallerySlider.on('resize', this._onGallerySliderResize);
			this._gallerySlider.mount();
		},

		_onGallerySliderWidth: function(){
			if( document.documentElement.clientWidth < 360 ){
				return 280;
			}
			if( document.documentElement.clientWidth < 768 ){
				return 318;
			}
			return 420;
		},

		_getGallerySliderCount: function(){
			return Math.max(1, Math.floor((document.documentElement.clientWidth - 26) / this._onGallerySliderWidth()));
		},

		_getGallerySliderPeek: function(count){
			return Math.ceil((document.documentElement.clientWidth - (count * this._onGallerySliderWidth())) / 2);
		},

		_onGallerySliderResize: function(){
			let count = this._getGallerySliderCount();
			this._gallerySlider.update({
				perView: count,
				peek: this._getGallerySliderPeek(count)
			});
		},

		onShow() {
			D.onLoad('Glide', this._drawSlider);
		},

		onLeave() {
			if (this._gallerySlider) {
				this._gallerySlider.destroy();
			}
		}
	},
	mkE.Base
)